import * as Dialog from "@radix-ui/react-dialog";
import { Button } from "../../Button";
import { Close, ArrowLeft } from "@/icons";
import "./BaseModalHeader.scss";
import { Col, Row } from "@/components";
import clsx from "clsx";

type BaseModalHeaderProps = {
  labels?: {
    closeButton?: string;
    backButton?: string;
  };
  onCloseClick?: () => void;
  onBackClick?: () => void;
  showBackButton?: boolean;
  children?: React.ReactNode;
  classNameModalHeader?: string;
};

export const BaseModalHeader = ({
  labels = {
    closeButton: "Chiudi",
    backButton: "Indietro",
  },
  onCloseClick,
  onBackClick,
  showBackButton = false,
  children,
  classNameModalHeader = "ui-base-modal-header",
}: BaseModalHeaderProps) => {
  return (
    <header className={clsx(classNameModalHeader, "bg-white br-t-x4")}>
      <Row alignItems={"center"} justifyContent={"space-between"}>
        {showBackButton && onBackClick && labels?.backButton ? (
          <Button
            size="4"
            textColor="primary"
            bg="transparent"
            aria-label="Torna indietro"
            onClick={onBackClick}
          >
            <ArrowLeft className="mr-x8" />
            {labels.backButton}
          </Button>
        ) : null}
        {onCloseClick && labels?.closeButton ? (
          <Dialog.Close asChild>
            <Button
              size="4"
              textColor="primary"
              bg="transparent"
              aria-label="Chiudi modale"
              onClick={onCloseClick}
              className="ui-base-modal-close"
            >
              {labels.closeButton}
              <Close className="ml-x8" />
            </Button>
          </Dialog.Close>
        ) : null}
      </Row>
      <Col>
        <Dialog.Title className="fs-3 text-slate-20 fw-bold">
          {children}
        </Dialog.Title>
      </Col>
    </header>
  );
};

export const BaseModalHeaderV2 = ({
  labels = {
    closeButton: "Chiudi",
  },
  onCloseClick,
  children,
  classNameModalHeader = "ui-base-modal-header",
}: BaseModalHeaderProps) => {
  return (
    <header className={clsx(classNameModalHeader, "bg-white br-t-x4")}>
      <Row justifyContent={"space-between"}>
        <Col />
        <Dialog.Title className="fs-3 text-slate-20 fw-bold">
          {children}
        </Dialog.Title>
        {onCloseClick && labels?.closeButton ? (
          <Dialog.Close asChild>
            <Button
              size="4"
              textColor="primary"
              bg="transparent"
              aria-label="Chiudi modale"
              onClick={onCloseClick}
              className="ui-base-modal-close"
            >
              {labels.closeButton}
              <Close className="ml-x8" />
            </Button>
          </Dialog.Close>
        ) : null}
      </Row>
    </header>
  );
};
